import { Mutations } from '@/store/types';
import Store from '@/store';
import {
  AvailableDeliverySlotDto,
} from '@eurogast/hub-client-typescript';

export class DefaultOrderDetailService {
  private static instance = new DefaultOrderDetailService();

  public static singleton(): DefaultOrderDetailService {
    return this.instance;
  }

  private constructor() {
  }

  public saveDeliverySlot(slot?: AvailableDeliverySlotDto) {
    Store.commit(
      {
        type: Mutations.DefaultOrderDetail.setDeliverySlot,
        deliverySlot: slot
      }
    );
  }

  public resetCheckoutState() {
    Store.commit(Mutations.DefaultOrderDetail.resetCheckoutState);
  }
}
